import * as Primitive from "@radix-ui/react-alert-dialog";
import type { ComponentProps } from "react";
import { cn } from "../lib/utils";

export const AlertDialog = Primitive.Root;
export const AlertDialogTrigger = Primitive.Trigger;
export const AlertDialogTitle = Primitive.Title;
export const AlertDialogDescription = Primitive.Description;
export const AlertDialogAction = Primitive.Action;
export const AlertDialogCancel = Primitive.Cancel;
export function AlertDialogContent({
  className,
  ...props
}: ComponentProps<typeof Primitive.Content>) {
  return (
    <Primitive.Portal>
      <Primitive.Overlay className="fixed inset-0 z-50 bg-black/50" />
      <Primitive.Content
        className={cn(
          "fixed left-1/2 top-1/2 z-50 w-full max-w-lg -translate-x-1/2 -translate-y-1/2 rounded-lg border bg-background p-6 shadow-lg dark:bg-popover dark:text-popover-foreground dark:border-border",
          className,
        )}
        {...props}
      />
    </Primitive.Portal>
  );
}
export function AlertDialogHeader(props: ComponentProps<"div">) {
  return <div {...props} />;
}
export function AlertDialogFooter(props: ComponentProps<"div">) {
  return <div className="mt-4 flex justify-end gap-2" {...props} />;
}
